import { BaseRequest, CoreApi, StatsResponse } from "@hokuto/jam-core";
import { MapApi } from "./map.js";
import { AtlasApi } from "./atlas.js";
import { StyleApi } from "./style.js";
import { TemplateApi } from "./template.js";
import * as Fetch from "./fetch.js";
import * as Params from "./params.js";
import * as Url from "./url.js";

export const JamApi = {
  Map: MapApi,
  Atlas: AtlasApi,
  Style: StyleApi,
  Template: TemplateApi,
  Stats: Fetch.fetchJSON<BaseRequest, StatsResponse>(CoreApi.Stats),
  Fetch,
  Params,
  Url,
};
